<template>
     <ul class="flex justify-center w-full m-auto font-valorant mt-4 md:w-5/6 lg:w-3/4">
  <li class="flex-1 mr-1">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500" to="/protectingbuyers">How we protect buyers</router-link>
  </li>
  <li class="flex-1 mr-1">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500" to="/protectingsellers">How we protect Sellers</router-link>
  </li>
  <li class="flex-1 mr-1">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500" to="/vanguard">Our stance on Riot vAnguArd</router-link>
  </li>  
</ul>
</template>

<script>


export default {
  name: 'BuyerSellerVanguard',
  data () {
    return {

    }
  },
 beforeMount(){

 },    
}
</script>


// WEBPACK FOOTER //
// src/components/BuyerSellerVanguard.vue